var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatMapViewSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.00004V14C0 14.5303 0.213916 15.0391 0.59451 15.4142C0.975274 15.7892 1.49163 16 2.02989 16H14.2089C14.7472 16 15.2635 15.7892 15.6443 15.4142C16.0249 15.0391 16.2388 14.5303 16.2388 14V2.00004C16.2388 1.46969 16.0249 0.960936 15.6443 0.585767C15.2635 0.21077 14.7472 0 14.2089 0H2.02989C1.49163 0 0.975278 0.21077 0.59451 0.585767C0.213916 0.960932 0 1.46969 0 2.00004ZM5.07474 14.9998H2.02998C1.76085 14.9998 1.50259 14.8945 1.31229 14.707C1.12199 14.5195 1.01512 14.2651 1.01512 13.9999V12.9999H5.07474V14.9998ZM5.07474 11.9998H1.01512V9.99996H5.07474V11.9998ZM5.07474 8.99985H1.01512V6.99998H5.07474V8.99985ZM10.1495 11.9998H6.08968V9.99996H10.1493L10.1495 11.9998ZM10.1495 5.99987H6.08968V4H10.1493L10.1495 5.99987ZM14.2091 14.9998H11.1643V12.9999H15.2239V13.9999C15.2239 14.265 15.1171 14.5195 14.9268 14.707C14.7365 14.8945 14.4782 14.9998 14.2091 14.9998ZM15.2239 11.9998H11.1643V9.99996H15.2239V11.9998ZM15.2239 8.99985H11.1643V6.99998H15.2239V8.99985ZM15.2239 2.99989H11.1643V1.00002H14.2091C14.4782 1.00002 14.7365 1.10532 14.9268 1.29282C15.1171 1.48032 15.2239 1.73476 15.2239 1.99996V2.99989Z",
    fill: "#2947FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMapViewSelectedIcon);
export default __webpack_public_path__ + "static/media/heatMapViewSelectedIcon.7c145b2970d524cbb91768104c9ff686.svg";
export { ForwardRef as ReactComponent };